import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Content } from 'antd/es/layout/layout';
import { footer } from './common';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

// 🔧 สร้างตารางรายการสินค้า
const genBody = (orders) => {
    let index = 1;
    const rows = _.compact(_.map(orders, (order) => {
        const product = order?.product;
        if (!product) return null;

        return [
            {
                text: index++, alignment: 'center',
                fontSize: 10,
            }, // เพิ่ม margin
            {
                text: ` ${product?.model_name?.trim() || ''}     ${product?.name?.trim() || ''} ${order?.serialNumber ? `(${order.serialNumber.trim()})` : ''}`.trim(),
                fontSize: 10,
                alignment: 'left',
            },
            {
                text: order?.warehouse?.name || '',
                fontSize: 10,
                alignment: 'center',
            },
            {
                text: `${order?.amount || 0} ${product?.unit || ''}`,
                fontSize: 10,
                alignment: 'center',
            }
        ];
    }));

    // เติมแถวว่างให้ครบ 15 แถว
    const MIN_ROWS = 35;
    while (rows.length < MIN_ROWS) {
        rows.push([
            { text: '', alignment: 'center', margin: [0, 6, 0, 6] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6] },
            { text: '', alignment: 'center', margin: [0, 6, 0, 6] }
        ]);
    }

    return [
        [
            { text: "ลำดับ", bold: true, alignment: "center", margin: [0, 2, 0, 2], fontSize: 12, },
            { text: "รายการสินค้า", bold: true, alignment: "center", margin: [0, 2, 0, 2], fontSize: 12, },
            { text: "คลังสินค้า", bold: true, alignment: "center", margin: [0, 2, 0, 2], fontSize: 12, },
            { text: "จำนวน", bold: true, alignment: "center", margin: [0, 2, 0, 2], fontSize: 12, }
        ],
        ...rows
    ];
};



const orderExport = async (productTransaction, setting) => {
    const docNumber = productTransaction?.running_number || '-';
    const docDate = productTransaction?.real_export_date ? dayjs(productTransaction?.real_export_date).format('D MMM BBBB ') : dayjs(productTransaction?.export_date).format('D MMM BBBB ')
    const requester =
        productTransaction?.export_employee?.firstname ||
            productTransaction?.export_employee?.lastname
            ? `${productTransaction?.export?.firstname || ''} ${productTransaction?.export_employee?.lastname || ''}`.trim()
            : `${productTransaction?.export_employee_real?.firstname || ''}  ${productTransaction?.export_employee_real?.lastname || ''}`;
    const genItemBody = genBody(productTransaction?.orders || []);
    console.log('productTransaction', productTransaction);

    const documentRef = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [20, 70, 40, 80],
        defaultStyle: {
            font: 'Sarabun',
            fontSize: 10,
        },
        header: [
            {
                margin: [20, 20, 20, 0],
                table: {
                    widths: ['*', '45%'],
                    body: [
                        [
                            {
                                text: "บริษัท วี ทู เอส เอ็นจิเนียริ่ง จำกัด",
                                style: 'bodyHeader',
                                fontSize: 14,
                                // alignment: "left",
                                border: [false, false, false, false],
                            },
                            {
                                text: "",
                                border: [false, false, false, false],
                                style: 'header',
                            },
                        ],
                        [
                            {
                                text: '',
                                border: [false, false, false, false],
                            },
                            {
                                text: "ใบส่งออกสินค้า",
                                alignment: 'right',
                                fontSize: 14,
                                style: 'header',
                                border: [false, false, false, false],
                            },
                        ],
                    ],
                },
            },
        ],
        content: [
            {
                margin: [0, 0, 0, 0],
                table: {
                    widths: ['*', '45%'],
                    body: [
                        [
                            { text: `จากคลัง: ${productTransaction?.orders?.[0]?.warehouse?.name || "-"} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `หมายเลขเอกสาร  ${docNumber} `, fontSize: 12, border: [false, false, false, false] },
                        ],
                        [
                            { text: `ลูกค้า: ${productTransaction?.customer?.name || "-"} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `วันที่ส่งออก: ${docDate} `, fontSize: 12, border: [false, false, false, false] },
                        ],
                        [
                            { text: `หมายเลขโครงการ: ${productTransaction?.project_number || "-"} `, fontSize: 12, border: [false, false, false, false] },
                            { text: `พนักงานขาย / ผู้เบิก: ${requester} `, fontSize: 12, border: [false, false, false, false] }
                        ],
                    ],
                },
            },
            {
                table: {
                    headerRows: 1,
                    widths: [30, '*', 90, 80],
                    body: genItemBody
                },
                layout: {
                    hLineWidth: function (i, node) {
                        if (i === 0 || i === 1 || i === node.table.body.length) return 0.5;
                        return 0;
                    },
                    vLineWidth: function () { return 0.5; },
                    hLineStyle: function () { return { dash: { length: 2, space: 2 } }; },
                    vLineStyle: function () { return { dash: { length: 2, space: 2 } }; },
                },
                // repeatHeader: true, // (option เสริม ถ้า fork รองรับ)
            }
        ],
        footer: function (currentPage, pageCount) {
            return {
                margin: [20, 0, 20, 0],
                table: {
                    widths: ['*'],
                    body: [
                        [
                            { text: '+-----------------------------------------------------------------------------------------------------------------------------------------------------------+', fontSize: 10, border: [false, false, false, false] },
                        ],
                        [
                            { text: 'ผู้รับสินค้า .......................................... วันที่ ........../.........../.............  ผู้ส่งสินค้า.....................วันที่.........../............/..............ขนส่ง ....................', fontSize: 10, border: [false, false, false, false] },
                        ],
                        [
                            { text: 'ผู้จัดทำ  ................................. RB........................................  คลังสินค้า ...........................ผู้ตรวจ .............................  ผู้อนุมัติ ............................', fontSize: 10, border: [false, false, false, false] },
                        ],
                        [
                            { text: '+-----------------------------------------------------------------------------------------------------------------------------------------------------------+', fontSize: 10, border: [false, false, false, false] },
                        ],
                        [
                            { text: `หน้า ${currentPage} / ${pageCount}`, alignment: 'right', fontSize: 9, border: [false, false, false, false] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        if (i === 0 || i === node.table.body.length) return 0.5;
                        return 0;
                    },
                    vLineWidth: function () { return 0.5; },
                    hLineStyle: function () { return { dash: { length: 2, space: 2 } }; },
                    vLineStyle: function () { return { dash: { length: 2, space: 2 } }; },
                },
            }
        },
        styles: {
            headerCompany: {
                fontSize: 13,
                bold: true
            },
            headerTitle: {
                fontSize: 12,
                bold: true
            },
            tableExample: {
                margin: [0, 0, 0, 0]
            }
        }
    };

    pdfMake.createPdf(documentRef).open();
};

export default orderExport;
